export default __webpack_public_path__ + "static/media/MapForm.2ad0920f.mrt";